import { FadeIn } from "../FadeIn";

const PROCESS = [
  { n: "01", t: "Contact", d: "Vous décrivez le projet, le terrain, les délais." },
  { n: "02", t: "Brief", d: "Repérages, logistique, sécurité et axes éditoriaux." },
  { n: "03", t: "Sur le terrain", d: "Captation en conditions réelles, depuis l'intérieur de l'effort." },
  { n: "04", t: "Livraison", d: "Sélection, post-production et livrables finaux." },
];

export const ProcessSection = () => (
  <section
    data-testid="process-section"
    className="section-pad container-x bg-ink border-t border-white/10"
  >
    <FadeIn>
      <div className="eyebrow mb-3">Méthode</div>
      <h2 className="font-display text-5xl md:text-7xl mb-16 max-w-3xl">
        Quatre étapes,{" "}
        <span className="italic text-stone">aucun raccourci</span>.
      </h2>
    </FadeIn>
    <div className="flex md:grid md:grid-cols-4 gap-6 md:gap-10
                    overflow-x-auto md:overflow-visible snap-x snap-mandatory scrollbar-hide
                    -mx-6 px-6 md:mx-0 md:px-0 pb-4 md:pb-0">
      {PROCESS.map((p, i) => (
        <FadeIn key={p.n} delay={i * 0.08}>
          <div data-testid={`process-${p.n}`} className="border-t border-stone/40 pt-6 snap-center shrink-0 w-[78vw] md:w-auto">
            <div className="font-display text-5xl md:text-6xl text-stone mb-5 md:mb-6">{p.n}</div>
            <h3 className="font-display text-2xl mb-3">{p.t}</h3>
            <p className="text-sm text-bone/60 leading-relaxed">{p.d}</p>
          </div>
        </FadeIn>
      ))}
    </div>
  </section>
);
